import { useTokenRefresh } from '@/hooks/useTokenRefresh';

export function TokenRefresher(): null {
  useTokenRefresh();
  return null;
}
